/**
 * Panchakarma Elements section – Intersection Observer animation, mobile delay
 */
(function() {
  const section = document.querySelector('.panchakarma-elements');
  if (!section) return;

  const isMobile = window.innerWidth <= 749;
  let animationReady = false;
  const MOBILE_DELAY = 2000;

  if (isMobile) {
    setTimeout(function() {
      animationReady = true;
    }, MOBILE_DELAY);
  } else {
    animationReady = true;
  }

  function triggerAnimation() {
    if (isMobile && !animationReady) return;

    section.classList.remove('animate');

    const images = section.querySelectorAll('.panchakarma-elements__image');
    images.forEach(function(img) {
      img.style.animation = 'none';
      img.style.opacity = '0';
      void img.offsetWidth;
      img.style.animation = '';
      img.style.opacity = '';
    });

    void section.offsetWidth;

    setTimeout(function() {
      section.classList.add('animate');
    }, 50);
  }

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        triggerAnimation();
      } else {
        section.classList.remove('animate');
      }
    });
  }, {
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
  });

  observer.observe(section);
})();
